import { HeaderActions } from '@fortem-monorepo/react-spa'
import { HeaderBar } from '@fortem-monorepo/react-spa'

import { CanAccess } from '@/components/CanAccess'
import { LayoutOutlet } from '@/components/LayoutOutlet'
import { NavigationTabs, NavigationTabsList } from '@/components/NavigationTabs'
import { AddMappingModal } from '@/components/dialogs/AddMappingModal'
import { AddSwapAggEntryModal } from '@/components/dialogs/AddSwapAggEntryModal'
import { UploadMappingsModal } from '@/components/dialogs/UploadMappingsModal'
import { OPERATIONS_LINKS } from '@/constants/links'
import { PERMISSIONS } from '@/constants/permissions'
import { AddMappingButton } from '@/pages/operations/components/AddMappingButton'
import { OpsContextProvider } from '@/pages/operations/ops-context'

export interface OperationsLayoutProps {}

export const OperationsLayout: React.FC<OperationsLayoutProps> = ({}) => {
  return (
    <OpsContextProvider>
      <HeaderBar>
        <NavigationTabs>
          <NavigationTabsList links={OPERATIONS_LINKS} />
        </NavigationTabs>
      </HeaderBar>
      <CanAccess permissions={[PERMISSIONS.WRITE_MAPPINGS]}>
        <HeaderActions>
          <AddMappingButton />
        </HeaderActions>
      </CanAccess>
      <LayoutOutlet />
      <AddMappingModal />
      <UploadMappingsModal />
      <AddSwapAggEntryModal />
    </OpsContextProvider>
  )
}
